<header>
    <p class="header-tittle">Validando tu perfil</p>
  </header>
  <app-navigation [currentStep]="7" [countSteppers]="7" [error]="error"></app-navigation>
  
<div class="layout-form" *ngIf="!isLoading && !error">
    <div>
        <div class="icon-container">
            <img class="icon-image" src="assets/icons/Confirmation-papel.svg" alt="check-icon">
            <h2>¡Estamos validando tu perfil!</h2>
        </div>
        <div class="text-informative-container">
            <h2>¿Qué sigue?</h2>
            <p>Te notificaremos por email cuando tu cuenta esté lista. El proceso puede tomar entre 24 a 48 horas.
            </p>
        </div>
    </div>
</div>
<div class="layout-form" *ngIf="!isLoading && error">
    <div>
        <div class="icon-container-error">
            <img class="icon-image" src="assets/icons/Alto-error.svg" alt="check-icon">
            <h3>Hubo un error de conexión</h3>
        </div>
        <div class="text-informative-container-error">
            <p><strong>No pudimos completar el alta, pero no perdiste nada.</strong> Tu información está lista para que vuelvas a intentar.</p>
            <hr style="border: none; border-top: 1px solid #e3e3e3; width: 80%;">
            <button *ngIf="error" id="continue-button" mat-raised-button class="next-button-error" (click)="retry()">Reintentar</button>
        </div>
    </div>
</div>

<div class="button-container" *ngIf="!isLoading && !error">
    <!-- <button *ngIf="!error" id="continue-button" mat-raised-button class="next-button" (click)="finish()">Finalizar</button> -->
</div>